
import {distinctUntilChanged, debounceTime} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { TreeItemPickerComponent } from '../tree-item-picker/tree-item-picker.component';
import { MyCompanySearchService } from '../../../core/data-services/company/my-company-search.service';
import { BannerNotificationsService, SpinnerService } from '../../../xform-compat';

import { Subject } from 'rxjs';


/**
 * Component class for tree item picker component child
 */
@Component({
    selector: 'rms-tree-item-picker-multicolumn',
    templateUrl: './tree-item-picker-multicolumn.component.html',
    styleUrls: ['./tree-item-picker-multicolumn.component.scss'],
    standalone: false
})
export class TreeItemPickerMulticolumnComponent extends TreeItemPickerComponent implements OnInit {

  public bulkCheckSelect = false;
  public searchField: string;
  public modelChanged: Subject<string> = new Subject<string>();

  constructor(
    private companySearchService: MyCompanySearchService,
    private bannerNotificationService: BannerNotificationsService,
    private spinnerService: SpinnerService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.filter();
  }

  /**
   * Select/unselect all unFollowed companies
   */
  public bulkSelect () {
    this.convertedItems.filter(item => {
      item.isChecked = (this.bulkCheckSelect);
      this.itemChanged(item, true, this.bulkCheckSelect);
    });
  }

  /**
   * Filters against the API to get companies matching the term
   * Waits 0.5 after the user stops typing to make the request
   */
  filter () {
    this.modelChanged.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.spinnerService.start();
        this.companySearchService.filterUnFollowedCompanies(value).subscribe(
          (items: any) => {
            this.updateItemsList(items.records);
            this.spinnerService.stop();
          },
          error => this.bannerNotificationService.error(error)
        );
      });
  }

  /**
   * Detects the change in the filter input and emits an event
   * The event is being catch in the filter method
   * @param {string} term
   */
  public filterChanged (term: string) {
    this.modelChanged.next(term);
  }

}
